require('./homeResolverService');

'use strict';

angular.module('app.home.homeController', [
    'app.home.homeResolverService'
])
    .controller('app.home.homeController', [
        '$scope', 'app.home.homeResolverService',
        function ($scope,homeResolverService) {
            homeResolverService.resolve();
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/home/homeController.js